export default __webpack_public_path__ + "static/media/42.68960e18.gif";